import { render, staticRenderFns } from "./StartInitialSettingTutorialModal.vue?vue&type=template&id=d2bd19b6&scoped=true&"
import script from "./StartInitialSettingTutorialModal.vue?vue&type=script&lang=js&"
export * from "./StartInitialSettingTutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./StartInitialSettingTutorialModal.vue?vue&type=style&index=0&id=d2bd19b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bd19b6",
  null
  
)

export default component.exports